import React from "react";
import styled from "styled-components";

import usePageBreadcrumbs from "../../hooks/usePageBreadcrumbs";
import BreadCrumbs, { BreadCrumbsBlock } from "./BreadCrumbs";

// Rendered once by PageWrapper for every page: CRM's breadcrumb + title block.
// The route's create action lives in the grid header, as it does in CRM.
const PageHeader = () => {
  const { crumbs, title } = usePageBreadcrumbs();

  return (
    <Wrap>
      <BreadCrumbsBlock pageTitle={title}>
        {crumbs.map(({ label, to }) => (
          <BreadCrumbs key={`${label}-${to || "current"}`} content={label} link={to} />
        ))}
      </BreadCrumbsBlock>
    </Wrap>
  );
};

export default PageHeader;

const Wrap = styled.div`
  flex-shrink: 0;
  padding: 1.5rem 1.5rem 1rem;
`;
